// extracted by mini-css-extract-plugin
export default {"ssoUrlContainer":"PI4IU95uAr","ssoUrlPrefix":"fDyBYWuGCr"};